import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Helpers } from '@recruitee/common';
import { IntegrationKinds } from '@recruitee/integrations-types';
import { OfferTranslations } from '@recruitee/offers-data';

import { IntegrationsHttpApiService } from './integrations-http-api.service';

export interface TranslateOfferRequest {
  messages: Array<{
    content: string;
    role: string;
  }>;
  temperature: number;

  offer?: OfferTranslations;
  offerTemplate?: OfferTranslations;
}

@Injectable({ providedIn: 'root' })
export class IntegrationsAiHttpClient {
  private integrationsApi = inject(IntegrationsHttpApiService);

  public translateOffer(body: TranslateOfferRequest): Observable<OfferTranslations> {
    return this.integrationsApi
      .post('offers/translate', undefined, body, { context: IntegrationKinds.AI })
      .pipe(map(response => Helpers.camelizeKeys(response)));
  }
}
